function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  d: "M1.7.4C1.1.4.4 1 .4 1.9v7.4c0 .9.7 1.4 1.3 1.4.2 0 .4 0 .6-.1l6.5-3.5c.4-.3.7-.7.7-1.2s-.2-1-.7-1.3L2.3.6C2.1.5 2 .4 1.7.4z"
});

var SvgPlay = function SvgPlay(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 10 11"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA5LjkgMTEuMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgOS45IDExLjE7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojRkZGRkZGO3N0cm9rZS13aWR0aDowLjU1O3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMS43LDAuNEMxLjEsMC40LDAuNCwxLDAuNCwxLjl2Ny40YzAsMC45LDAuNywxLjQsMS4zLDEuNGMwLjIsMCwwLjQsMCwwLjYtMC4xbDYuNS0zLjUKCQljMC40LTAuMywwLjctMC43LDAuNy0xLjJzLTAuMi0xLTAuNy0xLjNMMi4zLDAuNkMyLjEsMC41LDIsMC40LDEuNywwLjR6Ii8+CjwvZz4KPC9zdmc+Cg==";
export { SvgPlay as ReactComponent };